import { path } from 'ramda';
import { useSelector } from 'react-redux';

/**
 * Hook to be able to manage the displayed content depending on the current user role
 *
 * @typedef {Function} EqualsFn
 * @param {string} pRole
 *
 * @typedef {Function} IncludesFn
 * @param {string[]} pRoles
 *
 * @typedef {Function} NotIncludesFn
 * @param {string[]} pRoles
 *
 * @typedef {Object} RoleConditionalOutput
 * @property {string | undefined} value
 * @property {EqualsFn} equals
 * @property {IncludesFn} includes
 * @property {NotIncludesFn} notIncludes
 *
 * @returns {RoleConditionalOutput}
 */
// TODO: Move to hooks folder
const useRoleConditional = () => {
  const currentRole = useSelector(path(['user', 'data', 'role']));

  const equals = pRole => pRole === currentRole;
  const includes = pRoles => pRoles.includes(currentRole);
  const notIncludes = pRoles => !includes(pRoles);

  return {
    value: currentRole,
    equals,
    includes,
    notIncludes,
  };
};

export default useRoleConditional;
